<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px;">
        <div class="p-3">
            <Gallery :images="imagesForHeader" :keep-aspect-ratio="true" passClasses="max-h-[500px]" />
        </div>
        <div class="flex flex-col lg:flex-row pt-12 md:pt-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full lg:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Kirchengemeinde Olbersleben</h1>
                    <p class="text-lg text-gray-500 mt-3">Altar und Winterkirche</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        In den vergangenen Jahren, seit 2014, investierten engagierte Ehrenamtliche in der
                        Kirchengemeinde große Mühen, um den Gesamtwindruck des Kircheninneren zunehmend abzurunden. So
                        wurde 2016 der Kanzelaltar durch die Firma Busse restauriert. Seit 2015 stand bereits der Neubau
                        der Winterkirche im Kirchturm an. Nach dem Verkauf des Pfarrhauses mussten neue Gemeinderäume
                        gefunden werden. Die alte Winterkirche wurde vollkommen entkernt, ausgebaut und durch Küche und
                        Toilette ergänzt. Die Winterkirche ist komplett barrierefrei und kann für Feierlichkeiten und zu
                        anderen Zwecken gemietet werden.
                    </p>
                </div>
                <div>
                    <h2 class="font-written text-4xl">Das Kirchengebäude</h2>
                    <p class="text-lg text-gray-500 mt-3">Rückblick</p>
                    <div
                        class="flex sm:flex-row flex-col items-start gap-4 sm:items-center p-3 shadow-md rounded-md mt-5 max-w-[550px] bg-white">
                        <img src="/assets/kirchen/olbersleben/kirche-zeichnung.webp" class="w-40">
                        <p class="text-sm">Zeichnung des alten Kirchengebäudes</p>
                    </div>
                    <p class="mt-5 max-w-lg lg:max-w-xl">
                        Unser Kirchengebäude wurde bereits vor über 900 Jahren von Vorgängerbauten um 1100 angelegt. Bei
                        der Instandsetzung im Jahr 2003 wurden sehr alte Reste des Vorgängerbaus, z.B. in Form von
                        romanischen Ritzfugen vorgefunden. Der straßenzugewandte, polygonale Chor wurde später angebaut
                        und stammt aus der Zeit von 1550 bis 1605. Die Fassadenfarbigkeit dieser Zeit in hellem Ocker
                        wurde bei den Sanierungsarbeiten 2003 wiederhergestellt. Als sprechende Zeugnisse der
                        Baugeschichte konnten wertvolle historische Putzfunde in den Teilen erhalten und sichtbar neben
                        dem neuen Putz belassen werden. Sie bilden die lebendige Struktur der Kirchwand.
                    </p>
                    <div class="flex flex-col items-start gap-3 mt-12 max-w-[550px] rounded-md overflow-hidden bg-white shadow-md">
                        <img src="/assets/kirchen/olbersleben/orgel.webp" class="w-full">
                        <p class="text-sm p-3">Neue Technik lässt die Orgel in Olbersleben seit kurzem wieder erklingen. Es
                            sind zwar nicht die originalen Pfeifen, die man zu hören bekommt aber die hochwertige
                            elektronische Variante schenkt dem Kirchenraum wieder eine volle und schöne Akustik und mit
                            unserer Kantorin Frau Schaback auch wundervolle Musik.</p>
                    </div>
                    <div class="flex flex-col items-start gap-3 mt-5 max-w-[550px] rounded-md overflow-hidden bg-white shadow-md">
                        <img src="/assets/kirchen/olbersleben/kirchenraum.webp" class="w-full">
                        <p class="text-sm p-3">Angesichts der Fortschritte in der Gestaltung unserer schönen Kirche, darf
                            man auch mal gemütlich beieinandersitzen und sich über diesen schönen Kirchenraum freuen.
                            Das war auch beim Tag des offenen Denkmals im September zu erleben.</p>
                    </div>
                </div>
            </div>
            <div class="text-left sticky mt-16 lg:mt-0 flex-auto px-3 lg:px-0 pr-3 lg:pr-12 lg:pr-24 top-[115px] h-min">
                <div class="flex-auto lg:w-auto flex flex-col items-center">
                    <div class="flex flex-col w-full gap-3">
                        <!-- <p class="text-md text-gray-500 px-1">Kontakt</p>
                        <div class="flex flex-col w-full p-6 rounded-md bg-white"
                            style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                            <div>
                                <p class="font-bold">Hans-Ulrich Bayer (Pfarrer)</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Mobil</span> <a
                                            href="tel:017670817415" class="hover:underline">0176 / 70817415</a></p>
                                    <p class="flex"><span class="w-14 font-bold mr-8">E-Mail</span> <a
                                            href="mailto:hans-ulrich.bayer@ekmd.de"
                                            class="hover:underline">hans-ulrich.bayer@ekmd.de</a>
                                    </p>
                                </div>
                            </div>

                            <div class="mt-8">
                                <p class="font-bold">Pfarreramt Rastenberg</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Adresse</span> Lossaer Str. 8,
                                        <br>99636
                                        Rastenberg
                                    </p>
                                    <p class="flex"><span class="w-14 font-bold mr-8">Telefon</span> <a
                                            href="tel:03637780324" class="hover:underline">036377 / 80324</a></p>
                                </div>
                            </div>

                            <div class="mt-8">
                                <p class="font-bold">Öffnungszeiten</p>
                                <div class="flex flex-col gap-1 mt-3">
                                    <p class="flex"><span class="w-14 font-bold mr-8">Dienstag</span> 9.00 - 15.00 Uhr
                                    </p>
                                </div>
                            </div>
                        </div> -->
                        <div v-if="data.length > 0">
                            <p class="text-md text-gray-500 px-1 mt-3 mb-3">Nächster Gottesdienst</p>
                            <div class="flex flex-col gap-3">
                                <template v-for="(i, n) in data.slice(0, 2)" :key="n">
                                    <div class="bg-white rounded-md flex flex-col gap-3 text-left overflow-hidden select-none"
                                        style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);">
                                        <div class="flex items-center justify-between px-3 py-2 bg-gray-500">
                                            <p class="text-sm text-white">{{ i.date }}</p>
                                            <p class="text-sm text-white">{{ i.time }}</p>
                                        </div>
                                        <div class="flex gap-10 p-3">
                                            <div>
                                                <p class="font-bold">{{ i.title }}</p>
                                                <p class="text-sm text-gray-500">Thema des Gottesdienstes</p>
                                            </div>
                                            <div class="ml-auto text-right" :title="i.location">
                                                <p>{{ i?.location.split(',').reverse()[0].replace(/\d+/g, "") }}</p>
                                                <p class="text-sm text-gray-500">Ort</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <p class="mt-4 italic text-right text-xs text-gray-500">Daten von <a
                                    href="https://kg-rastenberg.ekmd-online.de/gottesdienste/"
                                    class="hover:underline hover:text-primary-default font-bold">kg-rastenberg.ekmd-online.de</a>
                                bereitgestellt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-11/12 mx-auto h-0.5 rounded-md bg-gray-300 mt-16 lg:mt-28"></div>
        <div class="flex flex-col p-12 lg:p-24 text-left">
            <h2 class="font-written text-4xl">Die neue Glocke</h2>
            <p class="text-lg text-gray-500 mt-3">Einholung und Weihung, 2014</p>
            <div class="mt-5 flex flex-wrap sm:flex-nowrap gap-2">
                <div class="w-96 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/olbersleben/glocke-1.webp" class="w-full aspect-[4/3] object-cover">
                    <div class="p-3 mt-3">
                        <p class="text-sm">Hier sieht man Herrn Silberhorn beim abstellen der alten Glocken hinter der Kirche.</p>
                    </div>
                </div>
                <div class="w-96 rounded-md shadow-md overflow-hidden bg-white">
                    <img src="/assets/kirchen/olbersleben/glocke-2.webp" class="w-full aspect-[4/3] object-cover">
                    <div class="p-3 mt-3">
                        <p class="text-sm">Eine der neuen Glocken kurz vor dem Aufzug. Die Freiwillige Feuerwehr übernahm die Absicherung.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Gallery from '@/components/gallery.vue';

export default {
    name: "Olbersleben",
    data() {
        return {
            data: [],
            imagesForHeader: [
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-9.webp",
                    alt: "Olbersleben 9",
                    objectCover: true
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-1.webp",
                    alt: "Olbersleben 1"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-2.webp",
                    alt: "Olbersleben 2"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-3.webp",
                    alt: "Olbersleben 3"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-4.webp",
                    alt: "Olbersleben 4"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-5.webp",
                    alt: "Olbersleben 5"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-6.webp",
                    alt: "Olbersleben 6"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-7.webp",
                    alt: "Olbersleben 7"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-8.webp",
                    alt: "Olbersleben 8"
                },
                {
                    url: "/assets/kirchen/olbersleben/olbersleben-10.webp",
                    alt: "Olbersleben 10"
                },
            ]
        }
    },
    components: {
        Gallery
    },
    async created() {
        this.data = (await this.$userStore.getData()).filter(f => f.location.includes("Olbersleben"));
    }
}
</script>